import React from "react";

/** tiny skeleton block */
const Skel = ({ className = "" }) => (
  <div
    className={`animate-pulse bg-gray-200/80 dark:bg-gray-700/40 ${className}`}
    aria-hidden="true"
  />
);

/**
 * One skeleton row (avatar + short line + right pill badge)
 */
const Row = () => (
  <li className="flex items-center gap-3 py-3">
    {/* avatar */}
    <Skel className="rounded-full w-11 h-11 shrink-0" />

    {/* single short line */}
    <Skel className="h-4 w-30 rounded-md grow max-w-[60%]" />

    {/* right-side pill badge */}
    <Skel className="h-6 w-20 rounded-lg ml-auto shrink-0" />
  </li>
);

/**
 * Props:
 * - count?: number  -> how many rows (default 5)
 * - showDivider?: boolean -> thin separators (default true)
 * - className?: string -> wrapper classes
 */
export default function ReferralListSkeletonMinimal({
  count = 5,
  showDivider = true,
  className = "",
}) {
  return (
    <ul className={`w-full ${className}`}>
      {Array.from({ length: count }).map((_, i) => (
        <React.Fragment key={`ref-skel-${i}`}>
          <Row />
          {showDivider && i < count - 1 && (
            <div className="h-px w-full bg-gray-200/80 dark:bg-gray-700/40" />
          )}
        </React.Fragment>
      ))}
    </ul>
  );
}
